import { render, staticRenderFns } from "./ZipLink.vue?vue&type=template&id=1752186f"
import script from "./ZipLink.vue?vue&type=script&lang=js"
export * from "./ZipLink.vue?vue&type=script&lang=js"
import style0 from "./ZipLink.vue?vue&type=style&index=0&id=1752186f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports